<template>
  <div class="city-map city-map--has-price-mode">
    <div class="city-map__map">
      <div class="city-map__toggle">
        <span class="city-map__toggle-label-text">
          {{ getToggleLabel() }}
        </span>

        <input
          id="is-price-mode"
          v-model="isPriceMode"
          class="city-map__toggle-input"
          type="checkbox"
        >

        <label
          class="city-map__toggle-label"
          for="is-price-mode"
        />
      </div>
      <div
        v-if="unavailable"
        class="city-map__toggle city-map__toggle--available"
      >
        <span class="city-map__toggle-label-text">
          {{ t('map.toggleLabelAvailable') }}
        </span>

        <input
          id="show-unavailable"
          v-model="showUnavailable"
          class="city-map__toggle-input"
          type="checkbox"
        >

        <label
          class="city-map__toggle-label"
          for="show-unavailable"
        />
      </div>

      <GoogleMap
        :options="options"
        @init="onGoogleMapInit"
      >
        <template v-if="isInitialized">
          <GoogleMarker
            v-for="marker in markers"
            :id="marker.id"
            :key="marker.id"
            :name="marker.name"
            :address="marker.address"
            :image="marker.image"
            :lat="marker.lat"
            :lng="marker.lng"
            :price="marker.price"
            :currency="marker.currency"
            :color="marker.color"
            :is-available="marker.isAvailable"
            :is-price-mode="isPriceMode"
            :show-unavailable="showUnavailable"
            :events="['click', 'mouseover']"
            @click="onMarkerClick"
            @init="onMarkerInit"
          />
        </template>
      </GoogleMap>
    </div>
  </div>
</template>

<script>
import GoogleMap from '../googleMap/googleMap.vue';
import GoogleMarker from '../googleMarker/googleMarker.vue';
import config from '../../js/modules/config';

export default {
  name: 'MapWithMarkers',

  components: {
    GoogleMap,
    GoogleMarker,
  },

  props: {
    options: {
      type: Object,
      required: true,
    },

    markers: {
      type: Array,
      required: false,
      default: () => [],
    },

    unavailable: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    isPriceMode: true,
    showUnavailable: true,
    google: null,
    isInitialized: false,
    bounds: null,
    map: null,
  }),

  watch: {
    markers() {
      if (!this.google) {
        this.bounds = null;
        return;
      }

      this.bounds = new this.google.maps.LatLngBounds();
    },
  },

  methods: {
    onGoogleMapInit({ google, map }) {
      this.isInitialized = true;
      this.google = google;
      this.map = map;
      this.bounds = new google.maps.LatLngBounds();
    },

    onMarkerInit({ marker }) {
      this.bounds.extend(marker.getPosition());
      this.map.fitBounds(this.bounds);
    },

    onMarkerClick({ id }) {
      this.$emit('marker-click', { id });
    },

    getToggleLabel() {
      return config('LABELS.MAP_TOGGLE_LABEL');
    },
  },
};
</script>
